export default __webpack_public_path__ + "static/media/admin_panel_settings_active.a62b7fc9.svg";